
import React from 'react';
import {Helmet, translate} from 'views/module';
import CaregiverListScene from 'views/scenes/caregiver/list/CaregiverList';

const App = (props) => {
  return (
    <>
      <Helmet>
        <title>{translate('dashboard.Helmet.title')}</title>
      </Helmet>
      <CaregiverListScene />
    </>
  );
};

export default App;
